import { render } from "./AuthLink.vue?vue&type=template&id=3ea15714"
import script from "./AuthLink.vue?vue&type=script&lang=js"
export * from "./AuthLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__